/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Result_Action_Hubspot_NoteInputs */



/**
* | output |
* | --- |
* | "Add a HubSpot note" |
*
* @param {Agent_Result_Action_Hubspot_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_result_action_hubspot_note = /** @type {((inputs?: Agent_Result_Action_Hubspot_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Result_Action_Hubspot_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("HubSpot-Notiz hinzufügen")
	return /** @type {LocalizedString} */ ("Add a HubSpot note")
});